export default "__VITE_PUBLIC_ASSET__61e7eec4__"